import {
  Alert,
  AlertIcon,
  Box,
  CircularProgress,
  CloseButton,
  Flex,
  Image,
  Text,
  useState
} from '@stars-ecom/shared-atoms-ui'
import debounce from 'lodash/debounce'
import isArray from 'lodash/isArray'
import React, { memo, useCallback, useContext, useEffect } from 'react'

import {
  bancontact,
  //americanExpress, cb,
  applePayLogo,
  mastercard,
  visa,
  paypalLogo
} from '../checkout/icones'
import { ApiContext, CartContext, PaymentContext, WebsiteContext } from '../context'
import { priceFormat } from '../utils'
import PaymentForm from './PaymentForm'
import PaymentModeItem from './PaymentModeItem'
import PledgPaymentForm from './PledgPaymentForm'

const windowGlobal = typeof window !== 'undefined' && window

const PaymentModeList = (props) => {
  const { cgv, error = '', closeErrorMsg = () => {} } = props
  const [paymentMethods, setPaymentMethods] = useState([])
  const [pledgError, setPledgError] = useState(false)
  const { paymentMethod, setPaymentMethod } = useContext(PaymentContext)
  const [loading, setLoading] = useState(false)
  const apiContext = useContext(ApiContext)
  const currentCart = useContext(CartContext)
  const websiteContext = useContext(WebsiteContext)

  const [hipayInstance, setHipayInstance] = useState()
  const [hipayErrorMessage, setHipayErrorMessage] = useState('')

  const hasOutOfStock = currentCart?.lines?.reduce(
    (a, c) => c.customFields.stockLevel === 'OUT_OF_STOCK' || a,
    false
  )
  const getEligiblePaymentMethods = async () => {
    setLoading(true)
    const result = await apiContext.OrderApi.eligiblePaymentMethods()
    if (result && isArray(result)) {
      setPaymentMethods(result?.filter((p) => p?.isEligible) || [])
    }
    setLoading(false)
  }
  const isAllInStock = () => {
    return currentCart?.lines?.every((item) => item?.productVariant?.stockLevel === 'IN_STOCK')
  }
  useEffect(() => {
    debounce(getEligiblePaymentMethods, 200)()
    if (paymentMethod && paymentMethods?.length >= 1) {
      setPaymentMethod(paymentMethods.find((pm) => pm.code === 'standard'))
    }
  }, [])

  useEffect(() => {
    if (!paymentMethod && paymentMethods?.length >= 1) {
      setPaymentMethod(paymentMethods.find((pm) => pm.code === 'standard'))
    }
  }, [paymentMethods])

  useEffect(() => {
    if (windowGlobal?.HiPay) {
      const hipay = windowGlobal?.HiPay({
        username: process.env.GATSBY_API_HIPAY_USERNAME,
        password: process.env.GATSBY_API_HIPAY_PASSWORD,
        environment: process.env.GATSBY_API_HIPAY_ENV,
        lang: 'fr'
      })
      setHipayInstance(hipay)
    }
  }, [ windowGlobal?.HiPay ])

  const displayPaymentMethods = useCallback(() => {
    const result = []
    const allItemIsInStock = isAllInStock()
    const standard = paymentMethods?.find((pm) => pm.code === 'standard')
    const applepay = paymentMethods?.find((pm) => pm.code === 'applepay')
    const paypal = paymentMethods?.find((pm) => pm.code === 'paypal')
    const multiple2 = paymentMethods.find((pm) => pm.code === 'multiple2')
    const multiple3 = paymentMethods.find((pm) => pm.code === 'multiple3')
    const multiple4 = paymentMethods.find((pm) => pm.code === 'multiple4')
    
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    const canUseApplePay = 'ApplePaySession' in window && window.ApplePaySession.canMakePayments();

    // this var enable multipayment of paypal if no other multipayment is available
    const multiPaypal = !multiple2 && !multiple3 && !multiple4;

    // display "Paiement comptant" if multiple-payment method is available (standard paiment-method should exist too)
    if ((standard || applepay || paypal) && (multiple2 || multiple3 || multiple4)) {
      result.push(
        <Text
          key="standard-mode"
          mt="20px"
          mb="10px"
          as="h3"
          style={{
            fontSize: '18px',
            color: 'rgb(36,42,48)',
            fontWeight: 700,
            fontFamily: websiteContext.fontFamily
          }}>
          Paiement comptant :
        </Text>
      )
    }
    if (standard) {
      result.push(
        <Flex direction="column" key="standard">
          <PaymentModeItem
            selected={paymentMethod?.code === 'standard'}
            paymentMethod={standard}
            head={
              <>
                <Text>{'Par carte bancaire'}</Text>
                <Flex pl="20px" w="90px" justifyContent="space-between">
                  <Image src={visa} w="32px" />
                  <Image src={mastercard} w="32px" />
                </Flex>
              </>
            }
            message={`Afin de sécuriser votre paiement, votre banque est susceptible de vous demander une
            authentification. Munissez-vous dès à présent de votre portable ou de votre smartphone
            au cas où.`}
            value="carte">
            <PaymentForm
              hipayInstance={hipayInstance}
              hipayErrorMessage={hipayErrorMessage}
              setHipayErrorMessage={setHipayErrorMessage}
              cgv={cgv}
              paymentMethod="standard"
              isMultiple={false}
              hasOutOfStock={hasOutOfStock}
            />
          </PaymentModeItem>
        </Flex>
      )
    }
    if (applepay && allItemIsInStock && (canUseApplePay || !isMobile)) {
      result.push(
        <Flex direction="column" key="applepay">
          <PaymentModeItem
              selected={paymentMethod?.code === 'applepay'}
              paymentMethod={{...applepay}}
              head={
                <>
                  <Text alignSelf="center" >Apple Pay</Text>
                  <Flex pl="20px" w="60px" justifyContent="space-between">
                    <Image src={applePayLogo} w="32px" />
                  </Flex>
                </>
              }
              message={`Afin de sécuriser votre paiement, votre banque est susceptible de vous demander une
              authentification. Munissez-vous dès à présent de votre portable ou de votre smartphone
              au cas où.`}
              value="carte">
                <PaymentForm
                  hipayInstance={hipayInstance}
                  hipayErrorMessage={hipayErrorMessage}
                  setHipayErrorMessage={setHipayErrorMessage}
                  cgv={cgv}
                  paymentMethod="applepay"
                  isMultiple={false}
                  hasOutOfStock={hasOutOfStock}
                  currentCart={currentCart}
                />
            </PaymentModeItem>
        </Flex>
      )
    }
    if (paypal && allItemIsInStock) {
      result.push(
        <Flex direction="column" key="paypal">
          <PaymentModeItem
              selected={paymentMethod?.code === 'paypal'}
              paymentMethod={{...paypal}}
              head={
                <>
                  <Text alignSelf="center">PayPal</Text>
                  <Flex pl="20px" w="60px" justifyContent="space-between">
                    <Image src={paypalLogo} w="40px" />
                  </Flex>
                </>
              }
              message={`Afin de sécuriser votre paiement, votre banque est susceptible de vous demander une
              authentification. Munissez-vous dès à présent de votre portable ou de votre smartphone
              au cas où.`}
              value="carte">
              <PaymentForm
                hipayInstance={hipayInstance}
                hipayErrorMessage={hipayErrorMessage}
                setHipayErrorMessage={setHipayErrorMessage}
                cgv={cgv}
                paymentMethod="paypal"
                isMultiple={multiPaypal} // this var enable multipayment of paypal if no other multipayment is available
                hasOutOfStock={hasOutOfStock}
                currentCart={currentCart}
              />
            </PaymentModeItem>
        </Flex>
      )
    }
    
    // if (bcontact) {
    //   result.push(
    //     <Flex direction="column" key="bcontact">
    //       <Text
    //         mt="20px"
    //         mb="10px"
    //         as="h3"
    //         style={{
    //           fontSize: '18px',
    //           color: 'rgb(36,42,48)',
    //           fontWeight: 700,
    //           fontFamily: websiteContext.fontFamily
    //         }}>
    //         Paiement Bancontact :
    //       </Text>
    //       <PaymentModeItem
    //         selected={paymentMethod?.code === 'bcontact'}
    //         paymentMethod={bcontact}
    //         head={
    //           <>
    //             <Text>{'Par carte bancaire'}</Text>
    //             <Flex pl="20px" w="90px" justifyContent="space-between">
    //               <Image src={bancontact} w="32px" />
    //             </Flex>
    //           </>
    //         }
    //         message={`Afin de sécuriser votre paiement, votre banque est susceptible de vous demander une
    //         authentification. Munissez-vous dès à présent de votre portable ou de votre smartphone
    //         au cas où.`}
    //         value="carte">
    //         <PaymentForm cgv={cgv} paymentMethod="bcontact" isMultiple={false} />
    //       </PaymentModeItem>
    //     </Flex>
    //   )
    // }

    // display "Paiement en plusieurs fois" if multiple-payment method is available
    if (multiple2 || multiple3 || multiple4/* || pledg4x || pledg3x*/) {
      result.push(
        <Text
          key="multiple-mode"
          mt="20px"
          mb="10px"
          as="h3"
          style={{
            fontSize: '18px',
            color: 'rgb(36,42,48)',
            fontWeight: 700,
            fontFamily: websiteContext.fontFamily
          }}>
          Paiement en plusieurs fois par carte bancaire :
        </Text>
      )
    }
    if (/*!pledg4x && !pledg3x &&*/ multiple2) {
      result.push(
        <PaymentModeItem
          key="multiple2"
          selected={paymentMethod?.code === 'multiple2'}
          paymentMethod={multiple2}
          head={
            <Text>
              {'Paiement en 2 fois, soit '}
              <strong>{`${priceFormat(currentCart?.totalWithTax / 2, 'EUR')}/mois¹ + ${priceFormat(
                multiple2?.customFields?.applicationFee || 0,
                'EUR'
              )}`}</strong>
              {' de frais de dossier²'}
            </Text>
          }
          value="carte">
          <PaymentForm
            hipayInstance={hipayInstance}
            hipayErrorMessage={hipayErrorMessage}
            setHipayErrorMessage={setHipayErrorMessage}
            cgv={cgv}
            paymentMethod="multiple2"
            isMultiple={true}
          />
        </PaymentModeItem>
      )
    }
    if (/*!pledg4x && !pledg3x &&*/ multiple3) {
      result.push(
        <PaymentModeItem
          key="multiple3"
          selected={paymentMethod?.code === 'multiple3'}
          paymentMethod={multiple3}
          head={
            <Text>
              {'Paiement en 3 fois, soit '}
              <strong>{`${priceFormat(currentCart?.totalWithTax / 3, 'EUR')}/mois¹ + ${priceFormat(
                multiple3?.customFields?.applicationFee || 0,
                'EUR'
              )}`}</strong>
              {' de frais de dossier²'}
            </Text>
          }
          value="carte">
          <PaymentForm
            hipayInstance={hipayInstance}
            hipayErrorMessage={hipayErrorMessage}
            setHipayErrorMessage={setHipayErrorMessage}
            cgv={cgv}
            paymentMethod="multiple3"
            isMultiple={true}
          />
        </PaymentModeItem>
      )
    }
    if (/*!pledg4x && !pledg3x &&*/ multiple4) {
      result.push(
        <PaymentModeItem
          selected={paymentMethod?.code === 'multiple4'}
          paymentMethod={multiple4}
          key="multiple4"
          head={
            <Text>
              {'Paiement en 4 fois '}
              <strong>{`${priceFormat(currentCart?.totalWithTax / 4, 'EUR')}/mois¹ + ${priceFormat(
                multiple4?.customFields?.applicationFee || 0,
                'EUR'
              )}`}</strong>
              {' de frais de dossier²'}
            </Text>
          }
          value="carte">
          <PaymentForm
            hipayInstance={hipayInstance}
            hipayErrorMessage={hipayErrorMessage}
            setHipayErrorMessage={setHipayErrorMessage}
            cgv={cgv}
            paymentMethod="multiple4"
            isMultiple={true}
          />
        </PaymentModeItem>
      )
    }
    // if (pledg4x) {
    //   result.push(
    //     <PaymentModeItem
    //       selected={paymentMethod?.code === 'pledg4x'}
    //       paymentMethod={pledg4x}
    //       key="pledg4x"
    //       idPledgButton="pledg-button-4x"
    //       head={
    //         <>
    //           <Text dangerouslySetInnerHTML={{ __html: pledg4x?.description }}></Text>
    //           <Flex pl="20px" w="90px" justifyContent="space-between">
    //             <Image src={visa} w="32px" />
    //             <Image src={mastercard} w="32px" />
    //           </Flex>
    //         </>
    //       }
    //       value="carte">
    //       <PledgPaymentForm
    //         idPledgButton="pledg-button-4x"
    //         paymentMethod="pledg4x"
    //         setPledgError={setPledgError}
    //         cgv={cgv}
    //       />
    //     </PaymentModeItem>
    //   )
    // }
    // if (pledg3x) {
    //   result.push(
    //     <PaymentModeItem
    //       selected={paymentMethod?.code === 'pledg3x'}
    //       paymentMethod={pledg3x}
    //       key="pledg3x"
    //       idPledgButton="pledg-button-3x"
    //       head={
    //         <>
    //           <Text dangerouslySetInnerHTML={{ __html: pledg3x?.description }}></Text>
    //           <Flex pl="20px" w="90px" justifyContent="space-between">
    //             <Image src={visa} w="32px" />
    //             <Image src={mastercard} w="32px" />
    //           </Flex>
    //         </>
    //       }
    //       value="carte">
    //       <PledgPaymentForm
    //         idPledgButton="pledg-button-3x"
    //         paymentMethod="pledg3x"
    //         setPledgError={setPledgError}
    //         cgv={cgv}
    //       />
    //     </PaymentModeItem>
    //   )
    // }
    // if (pledg10x) {
    //   result.push(
    //     <PaymentModeItem
    //       selected={paymentMethod?.code === 'pledg10x'}
    //       paymentMethod={pledg10x}
    //       key="pledg10x"
    //       idPledgButton="pledg-button-10x"
    //       head={
    //         <>
    //           <Text dangerouslySetInnerHTML={{ __html: pledg10x?.description }}></Text>
    //           <Flex pl="20px" w="90px" justifyContent="space-between">
    //             <Image src={visa} w="32px" />
    //             <Image src={mastercard} w="32px" />
    //           </Flex>
    //         </>
    //       }
    //       value="carte">
    //       <PledgPaymentForm
    //         idPledgButton="pledg-button-10x"
    //         paymentMethod="pledg10x"
    //         setPledgError={setPledgError}
    //         cgv={cgv}
    //       />
    //     </PaymentModeItem>
    //   )
    // }

    return result
  }, [paymentMethods, paymentMethod])

  return (
    <Box w="100%">
      <Text
        p={{ md: '13px 0' }}
        as="h1"
        fontSize={{ base: '17px', md: '22px' }}
        style={{
          color: 'rgb(36,42,48)',
          fontWeight: 700,
          fontFamily: websiteContext.fontFamily
        }}>
        Choisissez votre mode de paiement :
      </Text>
      {error && (
        <Alert status="error" mb="20px">
          <AlertIcon />
          {error}
          <CloseButton position="absolute" right="8px" top="8px" onClick={closeErrorMsg} />
        </Alert>
      )}
      {loading && <CircularProgress isIndeterminate color={websiteContext?.mainColor} />}
      {!loading && displayPaymentMethods()}
    </Box>
  )
}

export default memo(PaymentModeList)
